import { Box, Stack } from '@mui/material';
import dayjs from 'dayjs';
import { RiPulseFill } from 'react-icons/ri';
import { IGlobalJobDTO } from 'wisestep-api';
import {
  WsDetailsCard,
  WsIconCurrency,
  WsIconVisa,
  WsChip,
  WsChipVariants,
  WsIconText,
  WsColors,
  WsButton,
  WsIconViewJD,
} from 'wisestep-base';

const AppliedJobs = () => {
  const jobListArr: IGlobalJobDTO[] = [
    {
      id: 'eec69e1f-8990-4113-bb3f-1896818f036b',
      uniqueId: '1178ae11b14d934c83ffd199e3a47583',
      workspaceId: 'wisestep',
      workspaceName: 'wisestep',
      isGlobal: true,
      applyURL:
        'https://www.dice.com/jobs/detail/1178ae11b14d934c83ffd199e3a47583?searchlink=search%2F%3FcountryCode%3DUS%26radius%3D30%26radiusUnit%3Dmi%26page%3D2%26pageSize%3D1000%26filters.postedDate%3DONE%26filters.employmentType%3DCONTRACTS%257CTHIRD_PARTY%26language%3Den%252F&searchId=b635f557-6c23-4dde-bf56-bd4212569b60',
      description:
        "\nVDart Inc is the leading global provider of digital solutions, products and talent management company providing digital technology solutions in Automotive, Manufacturing, Energy & Utilities and Healthcare Industries. Led by a strong global team located across 10 countries including USA, Canada, Mexico, Brazil, UK, Japan, Australia & India. We are currently accepting applications from staffing firms for our Preferred Partner Program, where we align niche staffing firms with specific verticals based on their strengths. To apply, please visit: https://www.vdart.com/suppliers/    Job Title: Technical Delivery Manager/Architect Location: Cary, NC Duration: Contract  Potential responsibilities:  Development Delivery manager responsible for planning, execution, and delivery of the requirements for various initiatives. Work closely with customer's business, IT stakeholders and external vendors to understand, formulate and map requirements to deliverables which will include project's scope, time, cost management and control activities; identify and manage customer's cross-functional and vendors interactions, dependencies, and risks. Work with stakeholders to formulate and manage project's delivery framework, roadmap, and artifacts.    Must have:  10 - 15+ years of experience in designing and developing applications for On-Prem / cloud platforms. Hands on developer with good communication skills and passion for development best practices and Test-Driven Development. Experience and in building micro-services using NodeJS Express frameworks. Experience in Front-end technologies using Client-side / Server-side rendering patterns. Must have object-oriented design (OOD) patterns experience for separation of concerns, code reusability, security, and performance. Strong database skills preferable experience Experience with DevOps thought process.    Key Skills: Cloud, Microservice, NodeJS, FrontEnd, OOD, Devops   Referral Program: Ask our recruiting team about how you can be a part of our referral program. If you refer a candidate with the desired qualifications and your candidate accepts the role, you can earn a generous referral fee. We want to hire the best talent available and are committed to building great teams and partnerships.   We are Equal Employment Opportunity Employer.  VDart Inc  Alpharetta, GA  Follow us on Twitter for the hottest positions: @VDart_Jobs Follow us on Twitter: @vdartinc     \n",
      jobType: ['ContractCorpToCorp'],
      company: 'VDart, Inc.',
      createdOn: '2022-06-24T09:25:45.869Z',
      modifiedOn: '2022-06-24T09:25:45.869Z',
      createdBy: 'wisestep-bot',
      modifiedBy: 'wisestep-bot',
      rate: '$Negotiable',
      title: 'Technical Delivery Manager/Architect',
      skills: ['Devops', 'Cloud', 'OOD', 'nodejs', 'Frontend', 'Microservice'],
      locations: [
        {
          city: 'Cary',
          state: 'North Carolina',
          stateCode: 'NC',
          country: 'United States',
          countryCode: 'US',
          continent: 'North America',
          continentCode: 'NA',
          point: '35.79154,-78.7811169',
        },
      ],
      sourceOfJob: 'DICESEARCH',
      visas: [
        'OPT',
        'TN-VISA',
        'CPT',
        'H-1B',
        'L2-EAD',
        'H4-EAD',
        'GREEN CARD',
        'GREEN CARD EAD',
        'CITIZEN',
      ],
      isAppliedByConsultant: false,
    },
    {
      id: '94cc6651-71b0-4a6c-be64-6754bb14cd5d',
      uniqueId: '5b9b4caa886e0e053cefd001ed17ea53',
      workspaceId: 'wisestep',
      workspaceName: 'wisestep',
      isGlobal: true,
      applyURL:
        'https://www.dice.com/jobs/detail/5b9b4caa886e0e053cefd001ed17ea53?searchlink=search%2F%3FcountryCode%3DUS%26radius%3D30%26radiusUnit%3Dmi%26page%3D2%26pageSize%3D1000%26filters.postedDate%3DONE%26filters.employmentType%3DCONTRACTS%257CTHIRD_PARTY%26language%3Den%252F&searchId=b635f557-6c23-4dde-bf56-bd4212569b60',
      description:
        '\n VDart Inc is the leading global provider of digital solutions, products and talent management company providing digital technology solutions in Automotive, Manufacturing, Energy & Utilities and Healthcare Industries. Led by a strong global team located across 10 countries including USA, Canada, Mexico, Brazil, UK, Japan, Australia & India. We are currently accepting applications from staffing firms for our Preferred Partner Program, where we align niche staffing firms with specific verticals based on their strengths. To apply, please visit: https://www.vdart.com/suppliers/    Job Title: JDA Transportation Management Solution Architect Location: US OR Canada – Remote  Duration: Contract  Roles & Responsibilities   Leveraged as the JDA TMS solution expert for transformational projects/programs. Key contributor to the Change Management efforts for global or regional program implementations. To prepare and deliver presentations for user, management, and executive level audiences and Provide advice to customers regarding industry best practices and Process Methodology. Can demonstrate and facilitate Design, Develop, Integration Discussions of product functionality and product architecture (i.e. Show data and process flow from one JDA solution to another) for modifications, interfaces, reports and screens to ensure smooth integration between technical and functional business requirements. Provides level 3 non-technical support during the "go-live" period and level 3 user support. To be involve and provide input to the Global Technology Strategy, serving to the Governance Board, ensuring input in decision-making process. Therefore, it is critical to deliver high level assessments in a short period of time to ensure timely strategic decisions.  Takes a lead role in pro-active search for areas of process improvement and ensures connectivity to customers in the business in this respect.  Interacts with Business, Service Delivery and Service Providers in decision-making processes regarding new solutions.  Responsible to enforce and improve the best practices in the Retail Warehouse management applied to all logistic needs.  Pro-active involvement in the Global Technology growth and improvement in processes and service delivery.             Convert business requirements into technical terms for the development team, perform detailed design, obtain design acceptance from business stakeholders and reviewers, develop detailed designs including functional specification\'s. Conducts/leads business process analysis or design, construction, validation, and deployment phases of the project To handle RFP and Presales activity   Desired Skills & Experience  Around 15 years of IT experience with experience in architecting complex solutions for JDA products Expert knowledge of JDA product suite and AppExchange products Understanding of various third party integration methodologies supported by JDA Excellent understanding of overall Project Life Cycle (analysis, delivery, testing, quality, deployment etc) Thorough understanding of development methodologies like Waterfall, Agile, Hybrid Well versed with JDA data model and solution architecture Mandatory Experience JDA - Transportation Management   Interpersonal Skills  Excellent written, verbal and presentation skills Ability to effectively prioritize and execute tasks, and collaborate with various stakeholders and deliver in tight timelines Experience working in a team-oriented, collaborative environment    Key Skills: JDA, TMS, Agile   Referral Program: Ask our recruiting team about how you can be a part of our referral program. If you refer a candidate with the desired qualifications and your candidate accepts the role, you can earn a generous referral fee. We want to hire the best talent available and are committed to building great teams and partnerships.   We are Equal Employment Opportunity Employer.  VDart Inc  Alpharetta, GA  Follow us on Twitter for the hottest positions: @VDart_Jobs Follow us on Twitter: @vdartinc    \n',
      jobType: ['ContractCorpToCorp'],
      company: 'VDart, Inc.',
      createdOn: '2022-06-24T09:25:32.170Z',
      modifiedOn: '2022-06-24T09:25:32.170Z',
      createdBy: 'wisestep-bot',
      modifiedBy: 'wisestep-bot',
      rate: '$Negotiable',
      title: 'JDA Transportation Management Solution Architect',
      skills: ['Agile', 'TMS', 'JDA'],
      sourceOfJob: 'DICESEARCH',
      visas: [
        'OPT',
        'TN-VISA',
        'CPT',
        'H-1B',
        'L2-EAD',
        'H4-EAD',
        'GREEN CARD',
        'GREEN CARD EAD',
        'CITIZEN',
      ],
      isAppliedByConsultant: false,
    },
  ];
  const formattedDate = (date: string): string => dayjs(date).format('DD/MM/YYYY');

  return (
    <Box p={4}>
      {jobListArr?.map((job, index) => (
        <Box my={2} key={index}>
          <WsDetailsCard
            title={job.title}
            email={job.companyEmail}
            locationsArray={job.locations}
            detailsArray={[
              {
                icon: <WsIconCurrency />,
                labelName: job.rate ? job.rate : 'Not Available',
              },
              {
                icon: <WsIconVisa />,
                labelName: job.visa ? job.visa : 'Not Available',
              },
            ]}
            gridXs={3}
            skillsArray={job.skills}
            tagsArray={['tag1', 'tag2', 'tag3']}
            isActiveCard={true}
            rightChildren={
              <WsChip
                value={job.sourceOfJob ? job.sourceOfJob : 'Unknown'}
                variant={WsChipVariants.PRIMARY}
              />
            }
            postedByChildren={
              <Box ml={1}>
                <WsIconText
                  icon={<RiPulseFill color={WsColors.TheBlues500} />}
                  text={job.createdOn ? `Posted on: ${formattedDate(job.createdOn)}` : ''}
                />
              </Box>
            }
            footer={
              <Stack direction={'row'} p={2} spacing={2} width={'100%'} justifyContent="flex-end">
                <WsButton startIcon={<WsIconViewJD />} variant="outlined" size="large">
                  View JD
                </WsButton>
              </Stack>
            }
            isCheckBox={false}
          />
        </Box>
      ))}
    </Box>
  );
};

export default AppliedJobs;
